export default __webpack_public_path__ + "static/media/nofiles.cf66a5ea.svg";